/**
 * Clients that can access the merchant decision page (single vs multiple merchants).
 * All other clients are routed directly to single-merchant onboarding.
 */
export const DECISION_PAGE_CLIENT_IDS: number[] = [
  10643
];

export function hasDecisionPageAccess(clientId: number, isFdUser = false): boolean {
  if (isFdUser) {
    return true;
  }

  return DECISION_PAGE_CLIENT_IDS.includes(clientId);
}
